import { InjectionToken } from '@angular/core';

export const SIGNALR_DIAGNOSTIC_CLIENT = new InjectionToken<boolean>('signalr.diagnostic.client');
export const SIGNALR_LOGGING_ENABLED = new InjectionToken<boolean>('signalr.logging.enabled');
